import React, { memo } from 'react'
import PropTypes from 'prop-types'

import { FastField } from 'formik'

import Checkbox from './components/Checkbox'

const FormCheckbox = props => {
	const { layout, label, required } = props
	return (
		<FastField key={`${layout}_${label}_${required}`} {...props} type="checkbox">
			{({ field, meta: { touched, error } }) => {
				const errorText = touched ? error : ''

				return <Checkbox {...props} {...field} error={!!errorText && touched} helperText={errorText} value />
			}}
		</FastField>
	)
}

FormCheckbox.propTypes = {
	name: PropTypes.string.isRequired,
	// eslint-disable-next-line react/no-unused-prop-types
	usePaperColors: PropTypes.bool,
	label: PropTypes.string,
	required: PropTypes.bool,
	layout: PropTypes.string,
}

FormCheckbox.defaultProps = {
	layout: 'transparent',
	label: '',
	required: false,
}

export default memo(FormCheckbox)
